import type {
  ReceivedInvoiceQuarantineReason,
  ReceivedInvoiceRow,
} from "../api/receivedInvoicesApi";

// Razones de cuarentena en cristiano (spec §10). El backend no persiste la
// cédula del receptor real de un receptor_mismatch — el texto explica el
// porqué sin poder mostrar cuál era.
const QUARANTINE_TEXT: Record<ReceivedInvoiceQuarantineReason, string> = {
  receptor_mismatch:
    "Esta factura viene a nombre de una cédula distinta a la de esta finca. Revisá que el emisor la haya facturado a la cédula correcta.",
  xml_invalid: "El XML adjunto no se pudo leer. El correo original quedó guardado.",
  unsupported_type: "Tipo de comprobante no soportado (solo FE, NC, ND, TE y FEC).",
  no_xml_attachment: "Llegó un correo sin factura adjunta.",
};

export function quarantineReasonText(reason: ReceivedInvoiceQuarantineReason | null): string {
  if (reason === null) return "En cuarentena.";
  return QUARANTINE_TEXT[reason] ?? "En cuarentena.";
}

// Los correos sin XML son casi siempre la verificación de reenvío automático
// de Gmail (forwarding-noreply@google.com) — sin verlos el usuario no puede
// completar el reenvío, por eso se destacan en la bandeja (spec §10.4).
export function isForwardingVerificationCandidate(invoice: ReceivedInvoiceRow): boolean {
  return (
    invoice.pipelineStatus === "quarantined" && invoice.quarantineReason === "no_xml_attachment"
  );
}

// Código de confirmación del reenvío de Gmail. Formato real: el asunto trae
// "(#607452274) Confirmación de reenvío…" y el cuerpo "Código de confirmación:
// 607452274". Si ninguno calza, null — la card muestra el texto crudo y el
// usuario lo encuentra a mano.
export function extractGmailVerificationCode(invoice: ReceivedInvoiceRow): string | null {
  const fromSubject = /\(#(\d{5,12})\)/.exec(invoice.emailSubject ?? "");
  if (fromSubject?.[1]) return fromSubject[1];
  const fromBody = /(?:c[oó]digo de confirmaci[oó]n|confirmation code)\s*:?\s*(\d{5,12})/i.exec(
    invoice.emailText ?? "",
  );
  return fromBody?.[1] ?? null;
}
